// extracted by mini-css-extract-plugin
export default {"wrap":"CreditReportWidget_wrap__Vyeug","row":"CreditReportWidget_row__qyrCA","col":"CreditReportWidget_col__q6f50"};